import { css } from "../helpers/webComponents";
import { InventoryService } from "../services/InventoryService";

/** CSS affecting the {@link InventoryComponent} */
const styles: string = css`
    :host {
        font-family: "Onesize", Arial, sans-serif;
        width: 100vw; /* Volledige breedte van de viewport */
        height: 100vh; /* Volledige hoogte van de viewport */
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px; /* Ruimte tussen secties */
        border: none;
        box-shadow: none;
    }

    .inventory-title {
        text-align: center;
        font-size: 2rem; /* Maak de titel groter */
        font-weight: bold;
        color: #000000;
        margin-bottom: 20px; /* Ruimte onder de titel */
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5); /* Subtiele schaduw voor leesbaarheid */
    }

    .inventory-list {
        display: flex;
        flex-wrap: wrap;
        gap: 50px; /* Verminder de ruimte tussen items */
        justify-content: center;
        padding: 0;
        list-style: none;
        max-height: calc(100vh - 150px); /* Beperk de hoogte van de lijst */
        overflow-y: auto; /* Voeg scrollen toe als de lijst te groot is */
    }

    .inventory-item {
        background-color: #754200c9;
        border: 1px solid #010010;
        padding: 8px; /* Maak de padding kleiner */
        border-radius: 6px; /* Maak de hoeken iets minder rond */
        text-align: center;
        color: #000000;
        cursor: pointer;
        transition: background-color 0.3s ease, transform 0.2s ease, box-shadow 0.2s ease;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 90px; /* Verminder de ruimte binnen het item */
        height: 70px; /* Maak de items minder hoog */
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    .inventory-item img {
        width: 20px; /* Maak de afbeelding kleiner */
        height: 10px;
        object-fit: contain;
        border-radius: 4px;
    }

    .inventory-item:hover {
        background-color: #3e2903b7;
        transform: translateY(-2px); /* Verminder de hover-beweging */
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);
    }

    .inventory-button {
        background-color: #6c63ff;
        color: #fff;
        border: none;
        border-radius: 8px;
        padding: 8px 12px; /* Maak de knop iets kleiner */
        cursor: pointer;
        font-size: 0.8rem; /* Maak de tekst iets kleiner */
        font-weight: bold;
        text-transform: uppercase;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        transition: transform 0.2s ease;
    }

    .inventory-button img {
        width: 16px; /* Maak de afbeelding in de knop kleiner */
        height: 16px;
        object-fit: contain;
        margin-right: 4px;
    }

    .inventory-button:active {
        transform: translateY(0);
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
`;

export class InventoryComponent extends HTMLElement {
    private inventoryService: InventoryService;
    private inventoryList: string[] = [];

    public constructor() {
        super();
        this.inventoryService = new InventoryService();
    }

    public async connectedCallback(): Promise<void> {
        this.renderLoading();
        try {
            this.inventoryList = await this.inventoryService.getInventory();
            this.render();
            console.log(this.inventoryList);
        }
        catch {
            this.renderError();
        }
    }

    private renderLoading(): void {
        this.innerHTML = "<p>Loading inventory...</p>";
    }

    private renderError(): void {
        this.innerHTML = "<p>Failed to load inventory. Please try again later.</p>";
    }

    private addReloadButtonListener(): void {
        const reloadButton: HTMLButtonElement = this.querySelector("#reload-button") as HTMLButtonElement;
        reloadButton.addEventListener("click", () => {
            window.location.reload(); // Herlaad de pagina
        });
    }

    private render(): void {
        this.innerHTML = `
            <style>
                ${styles}
            </style>
            ${this.inventoryList.length === 0
                ? `
                    <p>You have no items in your inventory.</p>
                    <button class="inventory-button" id="reload-button">Back</button>
                `
                : `
                    <div class="inventory-title">Your Inventory</div>
                    <ul class="inventory-list">
                        ${this.inventoryList.map(item => `<li class="inventory-item">${item}</li>`).join("")}
                    </ul>
                    <button class="inventory-button" id="reload-button">Back</button>
                `}
        `;
        this.addReloadButtonListener();
    }
}
